<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">
                  {{ isUpdate ? 'Update Currency Rate' : 'Add New Currency Rate' }}
                </span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  &nbsp;X</v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Exchange Rate *"
                    v-model="formData.ex_rate"
                    :error-messages="errors.collect('Exchange Rate')"
                    v-validate="'required'"
                    data-vv-name="Exchange Rate"
                    type="number"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >
                {{ isUpdate ? 'Save' : 'Add' }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditModal', 'formData', 'isUpdate'],

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            Axios.put(`api/currency-rate/${this.formData.currency_rate_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: 'Updated successfully',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal('Error', error.response.data.message, 'error')
              })
          } else {
            Axios.post('api/currency-rate', this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: 'Added successfully',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal('Error', error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/currencyRate/addEdit.vue